import { Injectable } from '@angular/core';
import { BasePagedCrudService } from "../shared/crud/base-crud.service";
import { CreateNastaveniUcetniJednotkyDto, EditNastaveniUcetniJednotkyDto, UcetniJednotkaDto } from "./models/UcetniJednotkaDtos"
import { HttpClient } from "@angular/common/http";
import { CrudSettings, QueryParams } from "../shared/crud/abstractions/base-crud";
import { EnvironmentService } from '../core/environment/environment.service';
import {DialogService} from "../shared/dialog/dialog.service";
import {MatSnackBar} from "@angular/material/snack-bar";

export class NastaveniUcetniJednotkaCrudSettings implements CrudSettings<string, UcetniJednotkaDto> {
  baseUrl = '';
  postUrl = '';
  queryParam = 'kodUj';
  createSuffix = undefined;
  deleteSuffix = undefined;
  deleteIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  editSuffix = undefined;
  editMethod: 'PUT' | 'PATCH' = 'PUT';
  editIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  getListSuffix = undefined;
  getSuffix = undefined;
  getIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  idGetter = (entity: UcetniJednotkaDto) => entity.kod;

  mapper(kod: string): QueryParams {
    const dict = new Map<string, string>();
    dict.set('kod', kod);
    return { params: dict }
  }

  constructor(private environmentService: EnvironmentService) {
    this.baseUrl = this.environmentService.getConfig().api.pubgw + '/api/StrukturaUcetniJednotky/UcetniJednotka';
    this.postUrl = this.environmentService.getConfig().api.pubgw + '/api/StrukturaUcetniJednotky/NastaveniUcetniJednotky';
  }
}

@Injectable({
  providedIn: null
})
export class NastaveniUcetniJednotkaDataService
  extends BasePagedCrudService<string, UcetniJednotkaDto, CreateNastaveniUcetniJednotkyDto, EditNastaveniUcetniJednotkyDto>{

  constructor(private _http: HttpClient, private environmentService: EnvironmentService, override dialogService: DialogService) {
    super(_http, new NastaveniUcetniJednotkaCrudSettings(environmentService), dialogService);
  }
}
